import i18next from 'i18next';
import { generateUUID } from 'utils/math';

/**
 * 成就中心分頁
 * @property {string} [ACHIEVEMENT_TABS] - 成就中心分頁
 */

export const ACHIEVEMENT_TABS = {
    HOME: {
        value: 'home',
        label: 'label.achievement.home'
    },
    GOAL_SETTING: {
        value: 'goalSetting',
        label: 'label.achievement.goal_setting'
    },
    ACHIEVEMENT_PAGE: {
        value: 'achievementPage',
        label: 'label.achievement.achievement_page'
    },
    ACHIEVEMENT_PLAN_SETTINGS: {
        value: 'achievementPlanSettings',
        label: 'label.achievement.achievement_plan_settings'
    }
};

/**
 *
 * @namespace 成就中心路徑
 * @property {string} [HOME_PAGE='/admin/admin/achievement'] - 成就中心根目錄
 * @property {string} [CREATE_ACHIEVEMENT_PAGE='/admin/achievement/create'] - 成就中心建立頁
 */
export const HOME_PAGE = '/admin/achievement';
export const CREATE_ACHIEVEMENT_PAGE = '/admin/achievement/create';

/**
 * 成就中心目標類型
 * @property {string} [ACHIEVEMENT_TYPES] - 成就中心目標類型
 */

export const ACHIEVEMENT_TYPES = {
    POINTS_CHALLENGE: 1
};

export const getDefaultAchievementStyle = ({ keyVisionTitle } = {}) => ({
    // 主視覺
    keyVision: `{"isShowKeyVision":true,"customImgUrl":"","bgColor":"#FFDEBE","froalaEditor":"<div style=\\"min-height: calc(200px - 2rem); display:flex; flex-direction: column; justify-content: center; align-items: center;\\"><h2 class=\\"section-title\\"><span style=\\"color: rgb(255, 222, 190);\\"><strong class=\\"bold\\">✦ ${keyVisionTitle} ✦</strong></span></h2>\\n<h4 class=\\"inner-title\\"><span style=\\"color: rgb(255, 191, 128);\\"><strong class=\\"bold\\">${i18next.t(
        'label.achievement.key_vision.description'
    )}</strong></span></h4></div>","customMobileImgUrl":"","bgType":3,"defaultMainVisionType":2}`,
    // 背景
    background: '{"visualType":1,"color":"#1B2433","imgUrl":"","mobileImgUrl":""}',
    // 說明
    description: `{"isShowContent":true,"froalaContent":"<p class=\\"inner\\"style=\\"text-align: center;\\"><span style=\\"color: rgb(255, 191, 128);\\"><strong class=\\"bold\\">${i18next.t(
        'label.achievement.description.title'
    )}</strong></span></p>"}`
});

export const getDefaultAchievementLevelStyle = () => [
    {
        name: i18next.t('label.achievement.level.explorer'), // 等級名稱
        threshold: 0, // 門檻點數
        settings: {
            Styles: {
                // 等級圖示
                iconImageUrl: 'https://assets.fevercdn.com/promotion/img/bronze_level_mark.svg',
                // 等級視覺
                levelVisual:
                    '{"visualType":1,"textColor":"#D97700","bgColor":"#FFBF80","imgUrl":"","mobileImgUrl":""}',
                // 進度條
                progressBar: `{"progressIconType":1,"progressIconUrl":"","progressColor":["#FFBF80","#E87800"],"color":"#FFC266","hint":"${i18next.t(
                    'label.achievement.progress_bar.hint'
                )}"}`,
                // 自訂連結
                customLink: `{"isShowTitle":true,"froalaTitle":"<h4 class=\\"inner-title\\" style=\\"text-align: center;\\"><span style=\\"color: rgb(255, 255, 255);\\"><strong class=\\"bold\\">${i18next.t(
                    'label.achievement.custom_link.title'
                )}</strong></span></h4>","desktopItemsPerRow":6,"mobileItemsPerRow":3,"achievementCard":[{"id":"${generateUUID()}","imageUrl":"https://assets.fevercdn.com/promotion/img/image_button.svg","linkUrl":""},{"id":"${generateUUID()}","imageUrl":"https://assets.fevercdn.com/promotion/img/image_button.svg","linkUrl":""},{"id":"${generateUUID()}","imageUrl":"https://assets.fevercdn.com/promotion/img/image_button.svg","linkUrl":""}]}`,
                // 等級說明
                levelDescription: `{"isShowContent":true,"froalaContent":"<p class=\\"inner\\"style=\\"text-align: center;\\"><span style=\\"color: rgb(255, 191, 128);\\"><strong class=\\"bold\\">${i18next.t(
                    'label.achievement.level_description.title'
                )}</strong></span></p>"}`
            }
        }
    },
    {
        name: i18next.t('label.achievement.level.elite'), // 等級名稱
        threshold: 1000, // 門檻點數
        settings: {
            Styles: {
                // 等級圖示
                iconImageUrl: 'https://assets.fevercdn.com/promotion/img/silver_level_mark.svg',
                // // 等級視覺
                levelVisual:
                    '{"visualType":1,"textColor":"#3C95C5","bgColor":"#96C0DC","imgUrl":"","mobileImgUrl":""}',
                // // 進度條
                progressBar: `{"progressIconType":1,"progressIconUrl":"","progressColor":["#88BFE4","#0070E8"],"color":"#96C0DC","hint":"${i18next.t(
                    'label.achievement.progress_bar.hint'
                )}"}`,
                // 自訂連結
                customLink: `{"isShowTitle":true,"froalaTitle":"<h4 class=\\"inner-title\\" style=\\"text-align: center;\\"><span style=\\"color: rgb(255, 255, 255);\\"><strong class=\\"bold\\">${i18next.t(
                    'label.achievement.custom_link.title'
                )}</strong></span></h4>","desktopItemsPerRow":6,"mobileItemsPerRow":3,"achievementCard":[{"id":"${generateUUID()}","imageUrl":"https://assets.fevercdn.com/promotion/img/image_button.svg","linkUrl":""},{"id":"${generateUUID()}","imageUrl":"https://assets.fevercdn.com/promotion/img/image_button.svg","linkUrl":""},{"id":"${generateUUID()}","imageUrl":"https://assets.fevercdn.com/promotion/img/image_button.svg","linkUrl":""}]}`,
                // 等級說明
                levelDescription: `{"isShowContent":true,"froalaContent":"<p class=\\"inner\\"style=\\"text-align: center;\\"><span style=\\"color: rgb(255, 191, 128);\\"><strong class=\\"bold\\">${i18next.t(
                    'label.achievement.level_description.title'
                )}</strong></span></p>"}`
            }
        }
    },
    {
        name: i18next.t('label.achievement.level.legend'), // 等級名稱
        threshold: 2000, // 門檻點數
        settings: {
            Styles: {
                // 等級圖示
                iconImageUrl: 'https://assets.fevercdn.com/promotion/img/gold_level_mark.svg',
                // 等級視覺
                levelVisual:
                    '{"visualType":1,"textColor":"#D97000","bgColor":"#FFBC21","imgUrl":"","mobileImgUrl":""}',
                // 進度條
                progressBar: `{"progressIconType":1,"progressIconUrl":"","progressColor":["#FFC700","#FF6600"],"color":"#FFBC21","hint":"${i18next.t(
                    'label.achievement.progress_bar.hint'
                )}"}`,
                // 自訂連結
                customLink: `{"isShowTitle":true,"froalaTitle":"<h4 class=\\"inner-title\\" style=\\"text-align: center;\\"><span style=\\"color: rgb(255, 255, 255);\\"><strong class=\\"bold\\">${i18next.t(
                    'label.achievement.custom_link.title'
                )}</strong></span></h4>","desktopItemsPerRow":6,"mobileItemsPerRow":3,"achievementCard":[{"id":"${generateUUID()}","imageUrl":"https://assets.fevercdn.com/promotion/img/image_button.svg","linkUrl":""},{"id":"${generateUUID()}","imageUrl":"https://assets.fevercdn.com/promotion/img/image_button.svg","linkUrl":""},{"id":"${generateUUID()}","imageUrl":"https://assets.fevercdn.com/promotion/img/image_button.svg","linkUrl":""}]}`,
                // 等級說明
                levelDescription: `{"isShowContent":true,"froalaContent":"<p class=\\"inner\\"style=\\"text-align: center;\\"><span style=\\"color: rgb(255, 191, 128);\\"><strong class=\\"bold\\">${i18next.t(
                    'label.achievement.level_description.title'
                )}</strong></span></p>"}`
            }
        }
    }
];

export const getDefaultAchievementCreateLevelStyle = ({
    progressBarHint,
    customLinkTitle
} = {}) => ({
    settings: {
        Styles: {
            // 等級視覺
            levelVisual:
                '{"visualType":1,"textColor":"#D97700","bgColor":"#FFBF80","imgUrl":"","mobileImgUrl":""}',
            // 進度條
            progressBar: `{"progressIconType":1,"progressIconUrl":"","progressColor":["#FFBF80","#E87800"],"color":"#FFC266","hint":"${progressBarHint}"}`,
            // 自訂連結
            customLink: `{"isShowTitle":true,"froalaTitle":"<h4 class=\\"inner-title\\" style=\\"text-align: center;\\"><span style=\\"color: rgb(255, 255, 255);\\"><strong class=\\"bold\\">${customLinkTitle}</strong></span></h4>","desktopItemsPerRow":6,"mobileItemsPerRow":3,"achievementCard":[{"id":"${generateUUID()}","imageUrl":"https://assets.fevercdn.com/promotion/img/image_button.svg","linkUrl":""},{"id":"${generateUUID()}","imageUrl":"https://assets.fevercdn.com/promotion/img/image_button.svg","linkUrl":""},{"id":"${generateUUID()}","imageUrl":"https://assets.fevercdn.com/promotion/img/image_button.svg","linkUrl":""}]}`
        }
    }
});

// 進度標示類型
export const PROGRESS_BAR_ICON_TYPES = {
    LEVEL_ICON: 1,
    CUSTOM: 2
};

// 成就中心狀態
export const ACHIEVEMENT_STATUS = {
    OFFLINE: 0, // 未啟用
    ENABLE: 1, // 啟用
    DISABLE: 2 // 停用
};

export const ACHIEVEMENT_SEARCH_TYPE = {
    MEMBER_NAME: 1,
    MEMBER_ID: 2
};

export const ACHIEVEMENT_STATUS_TEST = {
    IS_NOT_TEST: 0,
    IS_TEST: 1
};
